import { ArrowLeftOutlined } from "@ant-design/icons";
import subTitleBarStyle from "./SubTitleBar.module.scss";
import CrrButton from "../UI/CrrButton/CrrButton";
import organizationsListStyles from "../../pages/SuperAdmin/OrganizationsList/OrganizationsList.module.scss";

class SubTitleBarProps {
  /**
   * @type {string}
   */
  children;

  /**
   * @type {boolean}
   */
  showBackBtn;

  /**
   * @callback onBackBtnClickCallBack
   */
  /**
   * @type {onBackBtnClickCallBack}
   */
  onBackBtnClick;
  showActions;
  onActionClick;
  actionsLabel;
}

/**
 * @param {SubTitleBarProps} props
 */
export default function SubTitleBar(props) {
  return (
    <div className={subTitleBarStyle.subtitleContainer}>
      {props.showBackBtn && (
        <ArrowLeftOutlined
          onClick={props.onBackBtnClick}
          style={{ fontSize: 24, color: "var(--text-primary)" }}
        />
      )}
      <h2>{props.children}</h2>
      {props?.showActions && (
        <CrrButton
          onClick={props?.onActionClick}
          className={`${organizationsListStyles.btn} ${subTitleBarStyle.adminActions} `}
        >
          {props?.actionsLabel}
        </CrrButton>
      )}
    </div>
  );
}
